/* eslint-disable react/no-array-index-key */
import React, {
  lazy,
  Suspense,
  Fragment
} from 'react';
import {
  Switch,
  Redirect,
  Route
} from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/select" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    path: '/wx-success',
    component: lazy(() => import('src/views/auth/WXSuccess'))
  },

  {
    exact: true,
    path: '/select',
    guard: AuthGuard,
    component: lazy(() => import('src/views/pages/SelectUserView/index'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/select" />
      },
      {
        exact: true,
        path: '/app/user',
        component: () => <Redirect to="/app/user/dashboard" />
      },
      {
        exact: true,
        path: '/app/user/account',
        component: lazy(() => import('src/views/user/AccountView'))
      },
      {
        exact: true,
        path: '/app/user/audiogram',
        component: lazy(() => import('src/views/user/AudiogramView'))
      },
      {
        exact: true,
        path: '/app/user/sessions',
        component: lazy(() => import('src/views/user/Sessions'))
      },
      {
        exact: true,
        path: '/app/user/dashboard',
        component: lazy(() => import('src/views/user/Dashboard'))
      },
      {
        exact: true,
        path: '/app/devices/hearingInstrument',
        component: lazy(() => import('src/views/devices/HearingInstrumentBrowseView'))
      },
      {
        exact: true,
        path: '/app/devices/hearingInstrument-detail',
        component: lazy(() => import('src/views/devices/HearinginstrumentDetailView'))
      },
      {
        exact: true,
        path: '/app/fitting',
        component: () => <Redirect to="/app/fitting/basic" />
      },
      {
        exact: true,
        path: '/app/fitting/basic',
        component: lazy(() => import('src/views/fitting/BasicFittingView'))
      },
      {
        exact: true,
        path: '/app/fitting/fine',
        component: lazy(() => import('src/views/fitting/FineFittingView'))
      },
      {
        exact: true,
        path: '/app/fitting/equipment-options',
        component: lazy(() => import('src/views/fitting/EquipmentOptionsView'))
      },
      {
        exact: true,
        path: '/app/fitting/data-storage',
        component: lazy(() => import('src/views/fitting/DataStorageView'))
      },
      {
        exact: true,
        path: '/app/fitting/audiogram-direct',
        component: lazy(() => import('src/views/fitting/AudiogramDirect'))
      },
      {
        exact: true,
        path: '/app/fitting/feedback',
        component: lazy(() => import('src/views/fitting/FeedbackRealEarTest'))
      },
    ]
  },
];

const renderRoutes = (routes) => (routes ? (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes
                    ? renderRoutes(route.routes)
                    : <Component {...props} />}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
) : null);

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
